import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Button } from "@/shared/components/shadcn/Button";
import { Input } from "@/shared/components/shadcn/Input";
import { FormField } from "@/shared/components/ui/FormField";
import type { BuilderField } from "@froppio/form-core";

interface BuilderChoiceSettingsProps {
  field: BuilderField;
  onChange: (field: BuilderField) => void;
}

export function BuilderChoiceSettings({ field, onChange }: BuilderChoiceSettingsProps) {
  function move(index: number, direction: -1 | 1) {
    const choices = [...field.choices];
    [choices[index], choices[index + direction]] = [choices[index + direction], choices[index]];
    onChange({ ...field, choices });
  }

  return (
    <section aria-label="Choice options" className="space-y-3">
      <h3 className="text-sm font-bold">Options</h3>
      {field.choices.map((choice, index) => (
        <div key={choice.value} className="space-y-1 rounded-xl border border-border p-2">
          <FormField id={`option-${choice.value}`} label={`Option ${index + 1}`}>
            <Input value={choice.label} onChange={event => onChange({
              ...field, choices: field.choices.map(item => item.value === choice.value ? { ...item, label: event.target.value } : item),
            })} />
          </FormField>
          <div className="flex justify-end">
            <Button variant="ghost" size="icon-sm" aria-label={`Move option ${index + 1} up`} disabled={index === 0} onClick={() => move(index, -1)}><ArrowUp aria-hidden="true" /></Button>
            <Button variant="ghost" size="icon-sm" aria-label={`Move option ${index + 1} down`} disabled={index === field.choices.length - 1} onClick={() => move(index, 1)}><ArrowDown aria-hidden="true" /></Button>
            <Button variant="ghost" size="icon-sm" aria-label={`Delete option ${index + 1}`} onClick={() => onChange({ ...field, choices: field.choices.filter(item => item.value !== choice.value) })}><Trash2 aria-hidden="true" /></Button>
          </div>
        </div>
      ))}
      <Button variant="outline" className="w-full" onClick={() => onChange({
        ...field, choices: [...field.choices, { value: `choice_${crypto.randomUUID()}`, label: "" }],
      })}><Plus aria-hidden="true" />Add option</Button>
    </section>
  );
}
